import React from "react";
import PageMeta from "../components/PageMeta";
import PageShell from "../components/PageShell";
import { BookingCTA, Section } from "../components/MarketingPrimitives";
import SuneelDhingraImage from "../assets/SuneelDhingra.jpg";

const AboutUs = () => {
  return (
    <PageShell>
      <PageMeta
        title="About | BestSalesCoach.ai"
        description="Learn about BestSalesCoach.ai, a Victoria, Australia-based AI GTM execution platform built for complex B2B sales, stakeholder intelligence, technical validation, and human-in-the-loop execution."
        canonicalPath="/aboutus"
      />
      <Section
        id="about-hero"
        eyebrow="About BestSalesCoach.ai"
        title="Built for Teams That Need Better GTM Execution, Not More CRM Admin"
        description="BestSalesCoach.ai was built from the reality of complex B2B sales. Revenue teams do not need another place to store notes. They need a system that helps them connect account signals, inspect deal quality, build champions, qualify opportunities, coach execution, and turn customer conversations into measurable next actions."
        tone="hero"
      >
        <div className="about-copy-stack">
          <p className="marketing-body-copy">
            We believe the future of GTM execution is evidence-based. CROs and founders should be able to see which accounts need action, which deals are real, where execution is leaking, and what actions can improve deal quality, execution discipline, and customer-facing momentum.
          </p>
          <p className="marketing-body-copy">
            BestSalesCoach.ai combines ICP discipline, sales methodology, MEDDICC, Value Creation Team principles, account strategy, stakeholder analysis, and AI coaching into one GTM execution platform.
          </p>
        </div>
      </Section>

      <Section
        id="founder-credibility"
        eyebrow="Founder credibility"
        title="Meet the Founder"
        description="The company perspective is grounded in enterprise AI, GTM execution, and practical experience applying MEDDICC and value creation principles."
        tone="light"
      >
        <div className="founder-card">
          <img src={SuneelDhingraImage} alt="Suneel Dhingra" className="founder-image" />
          <div>
            <h3>Suneel Dhingra</h3>
            <p className="founder-role">Founder, BestSalesCoach.ai / Value Creation Teams</p>
            <p className="marketing-body-copy">
              Enterprise AI Reliability &amp; Agentic AI Advisor; GTM execution and MEDDICC practitioner; experience across observability, enterprise sales engineering, AI systems, revenue execution, and Value Creation Teams.
            </p>
            <div className="hero-actions">
              <BookingCTA
                label="Book a 20-Minute Demo"
                variant="secondary"
                eventName="book_demo_click"
                sourcePage="aboutus"
                ctaClicked="about_book_20_min_demo"
                requestedOffer="BestSalesCoach.ai Platform Demo"
                buyerType="General"
                urlType="demo"
              />
            </div>
          </div>
        </div>
      </Section>
    </PageShell>
  );
};

export default AboutUs;
